import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {NgSelectModule} from '@ng-select/ng-select';
import {ClipboardModule} from 'ngx-clipboard';
import {MyDatePickerModule} from 'mydatepicker';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  exports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    CollapseModule,
    ClipboardModule,
    NgSelectModule,
    MyDatePickerModule,
    NgbPaginationModule,
  ]
})

export class SharedLibsModule {}
